import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { GetRegionsForVehicles } from "../../store/actions/regionActions";
import toyotacorolla from "../../assets/images/2019-toyota-corolla-dashboard-2000x1125.jpg";
import uber from "../../assets/images/uber-467x529.jpg";
import { Navbar, Nav } from "react-bootstrap";
import {
  signInAnonymously,
  deleteAnonUser,
} from "../../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import Loading from "../widgets/Loading";
import logo from "../../assets/images/logowhiterecmin.png";

class DriverLandingPage extends Component {
  state = {
    regions: [],
    selectedRegion: null,
  };

  componentDidMount() {
    document.title = "Driver";
    if (this.props.auth.uid) {
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        this.props.deleteAnonUser();
        return (ev.returnValue = "Are you sure you want to close?");
      });
      this.props.getRegions();
    } else {
      this.props.signInAnonymously();
    }
    console.log(this.props);
  }

  componentDidUpdate(prev, curr) {
    if (
      prev.auth.isEmpty === true &&
      this.props.auth.isEmpty === false &&
      this.props.auth.uid
    ) {
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        this.props.deleteAnonUser();
        return (ev.returnValue = "Are you sure you want to close?");
      });
      this.props.getRegions();
    } else if (
      prev.region.vregions !== this.props.region.vregions &&
      this.props.auth.uid !== null &&
      this.props.auth.uid !== undefined
    ) {
      const choices = [];
      this.props.region.vregions.forEach((t) => {
        choices.push(
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        );
      });
      this.setState({
        regions: choices,
        selectedRegion:
          this.props.region.vregions.length > 0
            ? this.props.region.vregions[0]
            : null,
      });
    }
    console.log("UPDATE");
    console.log(this.props);
  }

  render() {
    if (this.props.auth.uid && !this.props.region.loading) {
      return (
        <div>
          <section
            className="menu menu2 cid-smIpILaFmX"
            once="menu"
            id="menu2-0"
          >
            <Navbar
              collapseOnSelect
              expand="lg"
              className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
              style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
            >
              <div className="container-fluid">
                <Navbar.Brand className="navbar-brand" href="#home">
                  <span className="navbar-logo">
                    <a href="/">
                      <img
                        src={logo}
                        alt="MassTaxi"
                        title=""
                        style={{ height: "2rem" }}
                      />
                    </a>
                  </span>
                </Navbar.Brand>
                {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
                <Navbar.Toggle
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarNavAltMarkup"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <div className="hamburger">
                    <span />
                    <span />
                    <span />
                    <span />
                  </div>
                </Navbar.Toggle>
                <Navbar.Collapse
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <Nav className="navbar-nav nav-dropdown nav-right">
                    <Nav.Link
                      className="nav-link link text-white text-primary display-4"
                      href="/"
                    >
                      Back to Home
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </section>

          <section
            className="carousel slide cid-st8xQSw16G"
            data-interval="false"
            id="slider1-1v"
          >
            <div className="full-screen">
              <div
                className="mbr-slider slide carousel"
                data-keyboard="false"
                data-ride="carousel"
                data-interval="4000"
                data-pause="hover"
              >
                <div className="carousel-inner" role="listbox">
                  <div
                    className="carousel-item slider-fullscreen-image active"
                    data-bg-video-slide="false"
                    style={{ backgroundImage: `url(${toyotacorolla})` }}
                  >
                    <div className="container container-slide">
                      <div className="image_wrapper">
                        <div className="mbr-overlay" />
                        <img src={toyotacorolla} alt="" title="" />
                        <div className="carousel-caption justify-content-center">
                          <div className="col-10 align-left">
                            <h2
                              className="mbr-fonts-style display-1"
                              style={{ color: "white" }}
                            >
                              Earn Extra Cash By <br />
                              Using Your Speaker
                            </h2>
                            <div className="mbr-section-btn mt-3">
                              <a
                                className="btn btn-white display-4"
                                href="#image2-1w"
                              >
                                Learn More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="carousel-item slider-fullscreen-image"
                    data-bg-video-slide="false"
                    style={{ backgroundImage: `url(${toyotacorolla})` }}
                  >
                    <div className="container container-slide">
                      <div className="image_wrapper">
                        <div className="mbr-overlay" />
                        <img src={toyotacorolla} alt="" title="" />
                        <div className="carousel-caption justify-content-center">
                          <div className="col-10 align-left">
                            <h2 className="mbr-fonts-style display-1">
                              Full Flexibility On
                              <br />
                              How You Work
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="image2 cid-st8ya2ONTF" id="image2-1w">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-lg-5">
                  <div className="image-wrapper">
                    <img src={uber} alt="App" />
                    <p className="mbr-description mbr-fonts-style mt-2 align-center display-4">
                      MassTaxi Mobile App
                    </p>
                  </div>
                </div>
                <div className="col-12 col-lg">
                  <div className="text-wrapper">
                    <h3 className="mbr-section-title mbr-fonts-style mb-3 display-2">
                      <strong>Download Our App</strong>
                    </h3>
                    <p className="mbr-text mbr-fonts-style display-7">
                      The MassTaxi android application enables public transport
                      vehicle drivers to disseminate audio advertisements and
                      make money while they are at it. MassTaxi is a new
                      opportunity for public transport vehicle drivers to have a
                      secondary income (a side hustle) while putting a next to
                      none effort since the mobile application is highly
                      automated. The MassTaxi android application ensures
                      companies that their advertisement is being played loud
                      and clear by making sure that the passengers can clearly
                      hear the sound.
                      <br />
                      <br />
                      <div
                        className="mbr-arrow downloadapp"
                        id="download_circle_btn"
                        aria-hidden="true"
                      >
                        <a href="#next">
                          <i className="mbri-down mbr-iconfont" />
                        </a>
                        <br />
                        <br />
                        <br />
                        <h6 className="mbr-section-title download mbr-fonts-style mb-3 display-9 align-center">
                          <a href="#next">
                            <strong>Download</strong>
                          </a>
                        </h6>
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {!this.props.auth.isLoaded && (
            <div
              className="row justify-content-center"
              style={{ marginBottom: 40 }}
            >
              <h2 className="mbr-section-title mb-4 mbr-fonts-style align-center display-2">
                {" "}
                <br />
                <br />
                <strong>Loading</strong>
                <br />
                <div className="lds-ellipsis lds-ellipsis-white">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </h2>
            </div>
          )}
          {this.state.regions.length > 0 &&
            this.props.auth.isLoaded &&
            !this.props.auth.isEmpty && (
              <section className="form3 cid-st8ya2ONTF" id="form3-23">
                <div className="container ">
                  <div className="row justify-content-center">
                    <div className="col-lg-10">
                      <div className="row">
                        <div className="col-lg-6 col-12">
                          <div className="text-wrapper">
                            <h3 className="mbr-section-title mbr-fonts-style mb-3 display-2">
                              <strong>Change Driver</strong>
                            </h3>
                            <p className="mbr-text mbr-fonts-style display-5 text-danger">
                              This Only Applies For a Registered Taxi
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-lg-6 col-12 mbr-form"
                          data-form-type="formoid"
                        >
                          <form
                            action=""
                            method="POST"
                            className="mbr-form form-with-styler"
                            data-form-title="Form Name"
                          >
                            <div className="dragArea row">
                              <div
                                className="col-lg-12 col-md col-sm-12 form-group"
                                data-for="region"
                              >
                                <label
                                  for="regionfield"
                                  className="form-control-label mbr-fonts-style display-5"
                                >
                                  Select Your Region*
                                </label>
                                <select
                                  id="regionfield"
                                  name="region"
                                  onChange={(e) => {
                                    this.setState({
                                      selectedRegion:
                                        this.props.region.vregions.filter(
                                          function (event) {
                                            return event.id === e.target.value;
                                          }
                                        )[0],
                                    });
                                  }}
                                  className="form-control display-7"
                                  required
                                >
                                  {this.state.regions}
                                </select>
                              </div>
                              <div className="col-lg-12 col-md col-sm-12 form-group mbr-section-btn">
                                {this.state.selectedRegion !== null ? (
                                  <h3 className="mbr-section-title mbr-fonts-style mb-3 display-4">
                                    Please Call to contact{" "}
                                    {this.state.selectedRegion.name}
                                    <br />
                                    <strong>
                                      <a
                                        rel="noreferrer"
                                        target="_blank"
                                        href={
                                          "tel:" +
                                          this.state.selectedRegion.phone
                                        }
                                        className="text-primary display-5"
                                      >
                                        {this.state.selectedRegion.phone}
                                      </a>
                                    </strong>
                                  </h3>
                                ) : (
                                  ""
                                )}
                                {/* <button
                            type="submit"
                            style={{ width: "100%" }}
                            className="btn btn-black display-4"
                          >
                            Submit
                          </button> */}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className="offset-lg-1" />
                    </div>
                  </div>
                </div>
              </section>
            )}
          <section className="contacts2 cid-smJI7w9nls" id="contacts2-j">
            {/* <!----> */}

            <div className="container">
              <div className="mbr-section-head">
                <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                  <strong>Contacts</strong>
                </h3>
              </div>
              <div className="row justify-content-center mt-4">
                <div className="card col-12 col-md-6">
                  <div className="card-wrapper">
                    <div className="image-wrapper">
                      <span className="mbr-iconfont mobi-mbri-phone mobi-mbri" />
                    </div>
                    <div className="text-wrapper">
                      <h6 className="card-title mbr-fonts-style mb-1 display-5">
                        <strong>Phone</strong>
                      </h6>
                      <p className="mbr-text mbr-fonts-style display-7">
                        <a href="tel:+251986558559" className="text-primary">
                          +251 986 55 85 59
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card col-12 col-md-6">
                  <div className="card-wrapper">
                    <div className="image-wrapper">
                      <span className="mbr-iconfont mobi-mbri-letter mobi-mbri" />
                    </div>
                    <div className="text-wrapper">
                      <h6 className="card-title mbr-fonts-style mb-1 display-5">
                        <strong>Email</strong>
                      </h6>
                      <p className="mbr-text mbr-fonts-style display-7">
                        <a
                          href="mailto:masstaxiads@gmail.com"
                          className="text-primary"
                        >
                          masstaxiads@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="footer3 cid-smIvGalAcO"
            once="footers"
            id="footer3-1u"
          >
            <div className="container">
              <div className="media-container-row align-center mbr-white">
                <div className="row row-links">
                  <ul className="foot-menu">
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/" className="text-primary">
                        Home
                      </a>
                    </li>
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/contacts" className="text-primary">
                        Contact Us
                      </a>
                    </li>
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/driver" className="text-primary">
                        Driver
                      </a>
                    </li>
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/business_login" className="text-primary">
                        Login
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="row social-row">
                  <div className="social-list align-right pb-2">
                    <div className="soc-item">
                      <a
                        href="https://www.facebook.com/masstaxiads"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                      </a>
                    </div>
                    <div className="soc-item">
                      <a
                        href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row row-copirayt">
                  <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                    © MassTaxi 2021. Service Provided by DAST ICT Solutions PLC.
                    All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    region: state.region,
    firestore: state.firestore,
    airtime: state.airtime,
    // timeslots: state.firestore.ordered.timeSlot,
    // carmodels: state.firestore.ordered.carModel,
    // superpath: state.firestore.ordered.superPath
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRegions: () => dispatch(GetRegionsForVehicles()),
    signInAnonymously: () => dispatch(signInAnonymously()),
    deleteAnonUser: () => dispatch(deleteAnonUser()),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  DriverLandingPage
);
